export default Object.freeze({
  PAID: 'paid',
  NOT_PAID: 'not paid',
  FAILED: 'failed',
  TRIAL: 'trial',
})
